import { FALLBACK_PARTNER } from './trading.constants';

export const ACCOUNT_NAMES = {
  disona: {
    forex_real: 'Trading',
    forex_demo: 'Demo',
    investor_real: 'Copy-trading',
    master_real: 'Leader',
    commission_real: 'Commission',
  },
  [FALLBACK_PARTNER]: {
    forex_real: 'Standard',
    forex_demo: 'Demo',
    investor_real: 'Investor',
    master_real: 'Master',
    commission_real: 'Commission',
  },
};

export const ACCOUNT_TYPES = {
  forexReal: 'forex_real',
  forexDemo: 'forex_demo',
  investorReal: 'investor_real',
  masterReal: 'master_real',
  commissionReal: 'commission_real',
};

export const MASTER_ACCOUNT_OPTIONS = {
  min_copy_coefficient: 1,
  max_copy_coefficient: 20,
  min_deposit: 10,
  commission: 10,
  termAndCondition: false,
};

export const INVESTOR_ACCOUNT_OPTIONS = {
  master_account_id: null,
  termAndCondition: false,
};

export const STANDARD_ACCOUNT_OPTIONS = {
  leverage: 50,
  name: 'STANDARD',
};

export const DEMO_ACCOUNT_OPTIONS = {
  leverage: 50,
  name: 'DEMO',
};

export const MASTER_ACCOUNT_NECCESARY_DATA = {
  server_code: null,
  account_type: ACCOUNT_TYPES.masterReal,
  account_currency: 'USD',
};

export const INVESTOR_ACCOUNT_NECCESARY_DATA = {
  server_code: null,
  account_type: ACCOUNT_TYPES.investorReal,
  account_currency: 'USD',
};

export const STANDARD_ACCOUNT_NECCESARY_DATA = {
  account_type_key: ACCOUNT_TYPES.forexReal,
  currency: 'USD',
  provider: null,
};

export const DEMO_ACCOUNT_NECCESARY_DATA = {
  account_type_key: ACCOUNT_TYPES.forexDemo,
  currency: 'USD',
  provider: null,
};

export const MASTER_ACCOUNT_LEVERAGE_OPTIONS = [100];

export const INVESTOR_ACCOUNT_LEVERAGE_OPTIONS = [100];

export const STANDARD_ACCOUNT_LEVERAGE_OPTIONS = [50, 100, 200, 400, 500];

export const DISONA_STANDARD_ACCOUNT_LEVERAGE_OPTIONS = [100];

export const DICTIONARY_OF_HOLIDAYS = {
  christmas_day: '25.12',
  new_year: '01.01',
};

export const WEEK_DAYS = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
